import { render } from "./AboutLead.vue?vue&type=template&id=5ab4fd1b&scoped=true"
import script from "./AboutLead.vue?vue&type=script&lang=js"
export * from "./AboutLead.vue?vue&type=script&lang=js"

import "./AboutLead.vue?vue&type=style&index=0&id=5ab4fd1b&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab4fd1b"]])

export default __exports__